/* KitchenBuildr USP bar: scrolls only when the row doesn't fit. */
(function () {
  'use strict';

  function setup(bar) {
    var viewport = bar.querySelector('[data-kbu-viewport]');
    var track = bar.querySelector('[data-kbu-track]');
    var group = bar.querySelector('[data-kbu-group]');
    if (!viewport || !track || !group) return;

    var mode = bar.dataset.mode || 'auto';
    var speed = Number(bar.dataset.speed) || 26;

    /* Keep one pristine copy of the row to clone from */
    var template = group.cloneNode(true);
    template.removeAttribute('data-kbu-group');
    template.setAttribute('aria-hidden', 'true');
    template.classList.add('kbu__group--clone');

    function copies() { return bar.querySelectorAll('.kbu__group--clone').length + 1; }

    function setCopies(total) {
      var have = copies();
      while (have < total) {
        track.appendChild(template.cloneNode(true));
        have++;
      }
      var clones = bar.querySelectorAll('.kbu__group--clone');
      for (var i = clones.length - 1; have > total; i--, have--) clones[i].remove();
    }

    function measure() {
      bar.classList.remove('is-scrolling');       /* measure the row at rest */
      setCopies(2);
      var width = group.scrollWidth;
      var available = viewport.clientWidth;
      var scroll = mode === 'always' || (mode !== 'never' && width > available + 1);

      if (!scroll) {
        setCopies(1);
        bar.style.removeProperty('--kbu-duration');
        viewport.scrollLeft = 0;
        return;
      }

      /* Enough copies that half the track always covers the screen, so the loop never shows a gap */
      var per = Math.max(1, Math.ceil(available / Math.max(width, 1)));
      setCopies(per * 2);
      bar.classList.add('is-scrolling');

      /* Even pace on every screen: the loop stretches with the row, not the window */
      var distance = per * width;
      bar.style.setProperty('--kbu-duration', Math.max(10, Math.round(speed * distance / 1000)) + 's');
    }

    var frame;
    function schedule() {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(measure);
    }

    measure();
    window.addEventListener('resize', schedule);
    if (window.ResizeObserver) new ResizeObserver(schedule).observe(viewport);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  }

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-kbu]'), function (bar) {
      if (bar.__kbuReady) return;
      bar.__kbuReady = true;
      setup(bar);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();